// 去除多余空格
export const trimValue = (value: string): string => value.replace(/\s/g, '');

// 去除 首尾的空格符
export const leadTrailTrim = (value: string): string => (typeof value === 'string' ? value.trim() : value);

// 过滤所有的空字符
export const trimAll = (value?: string): string => {
  if (typeof value === 'string') {
    return value.replace(/\s/g, '');
  }

  return value || '';
};
